import './BillingListingTableHeader.scss';
const BillingListingTableHeader = () => {
  return (
    <div className="billingListingTableHeader">
      <div className="tableField id">ID</div>
      <div className="tableField client">Cliente</div>
      <div className="tableField billingEntityBord">Razón social de Bord</div>
      <div className="tableField warehouse">Bodega</div>
      <div className="tableField invoiceNumber">N° de factura</div>
      <div className="tableField month">Mes</div>
      <div className="tableField amount">Monto</div>
      <div className="tableField billlingStatus">Estado de la factura</div>
      <div className="tableField actions">Acciones</div>
    </div>
  );
};

export default BillingListingTableHeader;
